export const environment = {
    production: true,
    url: "https://app.segurosreservas.com/",
    endpoint_auth: "https://kappa.segurosreservas.com:1443/SRAPI_Auth/api",
    endpoint_quotes: "https://app.segurosreservas.com/srapi_quotes/api/v1/",
    endpoint_general: "https://kappa.segurosreservas.com:1443/srapi_general/api/v1/",
    endpoint_maritime: "https://kappa.segurosreservas.com:1443/SRAPI_Maritime/api/v1/",
    endpoint_maritime_v2: "https://kappa.segurosreservas.com:1443/SRAPI_Maritime/api/v2/",
    endpoint_int365:"https://kappa.segurosreservas.com:1443/SRGT_INT365/api",
    client_id:"PortalMaritimo"
};